import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { GetSampleRowsByQreIdSurveyDataResponse } from '../../api/generated-evs/types.gen';
import { defineStyles, theme } from '../../theme';

const styles = defineStyles({
  root: {
    ml: 2,
    px: 1,
    py: 0.25,
    border: '1px solid',
    borderColor: '#ffffff66',
    borderRadius: 1,
    fontSize: 11,
    fontWeight: 700,
    whiteSpace: 'nowrap',
    color: theme.vars.palette.common.white,
  },
  srOnly: {
    position: 'absolute',
    width: 1,
    height: 1,
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    whiteSpace: 'nowrap',
  },
});

const messages = defineMessages({
  NFIELD: { id: 'topBar.engine.nfield', defaultMessage: 'Nfield' },
  EXTERNAL: { id: 'topBar.engine.external', defaultMessage: 'External link' },
  title: { id: 'topBar.engine.title', defaultMessage: 'Dotazovač: {engine}' },
  prefix: { id: 'topBar.engine.prefix', defaultMessage: 'Dotazovač:' },
});

export type TopBarEngineLabelProps = {
  engine?: GetSampleRowsByQreIdSurveyDataResponse['engine'];
};

const TopBarEngineLabel: FC<TopBarEngineLabelProps> = ({ engine }) => {
  const intl = useIntl();

  if (engine !== 'NFIELD' && engine !== 'EXTERNAL') {
    return null;
  }

  const label = intl.formatMessage(messages[engine]);
  const title = intl.formatMessage(messages.title, { engine: label });

  return (
    <Tooltip title={title} describeChild>
      <Typography component="span" sx={styles.root}>
        <Box component="span" sx={styles.srOnly}>
          {`${intl.formatMessage(messages.prefix)} `}
        </Box>
        {label}
      </Typography>
    </Tooltip>
  );
};

export default TopBarEngineLabel;
